<div class="section-divider d-none d-md-flex align-items-center gap-3 my-3">
  <div class="flex-grow-1 border-top"></div>
  <span class="fw-semibold small text-uppercase text-muted px-1" style="letter-spacing:.08em;">🌡 Klima</span>
  <div class="flex-grow-1 border-top"></div>
</div>

<!-- Thermometer Cards -->
<div *ngIf="thermometers.length > 0">
  <div class="d-flex align-items-center gap-2 mb-2 mt-md-0 mt-0">
    <span class="badge bg-danger" style="font-size:.7rem;letter-spacing:.05em;"><span [style.opacity]="liveDotOn ? '1' : '0'">●</span> LIVE</span>
    <span class="fw-semibold small text-uppercase">{{ 'THERMOMETER' | translate }}</span>
    <span *ngIf="thermoUpdatedAt" class="text-muted" style="font-size:.65rem;">· {{ 'UPDATED_AGO' | translate:{time: updatedAgo(thermoUpdatedAt)} }}</span>
  </div>
  <div class="row g-2 mb-3" [class.section-flash]="thermoFlash">
    <div class="col-6 col-sm-4 col-lg-3" *ngFor="let t of thermometers">
      <ng-template #thermoPopup>
        <ng-container *ngTemplateOutlet="chartTpl; context:{t: t, full: false}"></ng-container>
      </ng-template>
      <ng-template #thermoTapTpl>
        <ng-container *ngTemplateOutlet="chartTpl; context:{t: t, full: true}"></ng-container>
      </ng-template>
      <app-popup-card popupMaxWidth="90vw" [popupTpl]="thermoPopup" [tapTpl]="thermoTapTpl">
        <ng-template #body>
          <div class="card-body p-2 p-sm-3">
            <div class="d-flex align-items-center thermo-row">
              <svg xmlns="http://www.w3.org/2000/svg" width="1.4em" height="1.4em" fill="currentColor" viewBox="0 0 16 16" class="flex-shrink-0 text-muted d-none d-sm-inline">
                <path d="M9.5 12.5a1.5 1.5 0 1 1-2-1.415V6.5a.5.5 0 0 1 1 0v4.585a1.5 1.5 0 0 1 1 1.415"/>
                <path d="M5.5 2.5a2.5 2.5 0 0 1 5 0v7.55a3.5 3.5 0 1 1-5 0zM8 1a1.5 1.5 0 0 0-1.5 1.5v7.987l-.167.15a2.5 2.5 0 1 0 3.333 0L9.5 10.486V2.5A1.5 1.5 0 0 0 8 1"/>
              </svg>
              <span class="fw-bold text-truncate" style="min-width:0;flex:1;">{{ sensorName(t.name) }}</span>
              <span class="text-nowrap" style="flex-shrink:0;"><span [class]="tempColor(t.tempC)">{{ t.tempC.toFixed(1) }}°</span><ng-container *ngIf="t.humidity != null"><span class="d-inline d-sm-none text-muted" style="padding:0 3px;opacity:.4;">|</span><span class="d-none d-sm-inline">&thinsp;
                <svg xmlns="http://www.w3.org/2000/svg" width="1.1em" height="1.1em" fill="currentColor" viewBox="0 0 16 16" [class]="humidityColor(t.humidity)" style="vertical-align:-.05em;">
                  <path fill-rule="evenodd" d="M7.21.8C7.69.295 8 0 8 0c.109.845.468 1.69 1.036 2.572C10.055 4.218 11 5.445 11 7a3 3 0 0 1-6 0c0-1.555.95-2.78 1.964-4.428C7.15 1.486 7.21.8 7.21.8"/>
                </svg></span><span [class]="humidityColor(t.humidity)">{{ t.humidity.toFixed(0) }}%</span></ng-container></span>
            </div>
            <ng-container *ngIf="sparklinePoints(t.deviceId).length >= 1">
              <div class="d-flex align-items-center justify-content-between" style="margin-top:4px;">
                <app-sparkline-chart
                  [points]="sparklinePoints(t.deviceId)"
                  [darkMode]="darkMode"
                  [mode]="getMode(t.deviceId)"
                  style="display:block;flex:1;min-width:0;">
                </app-sparkline-chart>
                <button *ngIf="t.humidity != null"
                  (click)="toggleMode($event, t.deviceId)"
                  class="btn btn-link flex-shrink-0"
                  style="padding:10px 12px;opacity:.65;line-height:1;"
                  title="Zwischen Temperatur und Luftfeuchtigkeit umschalten">
                  <ng-container *ngIf="getMode(t.deviceId) === 'temp'">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1.3em" height="1.3em" fill="currentColor" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M7.21.8C7.69.295 8 0 8 0c.109.845.468 1.69 1.036 2.572C10.055 4.218 11 5.445 11 7a3 3 0 0 1-6 0c0-1.555.95-2.78 1.964-4.428C7.15 1.486 7.21.8 7.21.8"/>
                    </svg>
                  </ng-container>
                  <ng-container *ngIf="getMode(t.deviceId) === 'humidity'">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1.3em" height="1.3em" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M9.5 12.5a1.5 1.5 0 1 1-2-1.415V6.5a.5.5 0 0 1 1 0v4.585a1.5 1.5 0 0 1 1 1.415"/>
                      <path d="M5.5 2.5a2.5 2.5 0 0 1 5 0v7.55a3.5 3.5 0 1 1-5 0zM8 1a1.5 1.5 0 0 0-1.5 1.5v7.987l-.167.15a2.5 2.5 0 1 0 3.333 0L9.5 10.486V2.5A1.5 1.5 0 0 0 8 1"/>
                    </svg>
                  </ng-container>
                </button>
              </div>
              <div class="d-flex justify-content-between" style="font-size:.6rem;line-height:1;margin-top:1px;">
                <span class="text-muted" *ngIf="getMode(t.deviceId) === 'temp'">{{ sparklineMinMax(t.deviceId).min.toFixed(1) }}°</span>
                <span class="text-muted" *ngIf="getMode(t.deviceId) === 'humidity'">{{ sparklineMinMax(t.deviceId).minHum.toFixed(0) }}%</span>
                <span class="text-muted">24h</span>
                <span class="text-muted" *ngIf="getMode(t.deviceId) === 'temp'">{{ sparklineMinMax(t.deviceId).max.toFixed(1) }}°</span>
                <span class="text-muted" *ngIf="getMode(t.deviceId) === 'humidity'">{{ sparklineMinMax(t.deviceId).maxHum.toFixed(0) }}%</span>
              </div>
            </ng-container>
          </div>
        </ng-template>
      </app-popup-card>
    </div>
  </div>
</div>

<!-- Chart template — full=false for hover popover, full=true for click overlay -->
<ng-template #chartTpl let-t="t" let-full="full">
  <div class="fw-semibold small text-center mb-1">{{ sensorName(t.name) }}</div>
  <app-sparkline-chart
    [points]="sparklinePoints(t.deviceId)"
    [darkMode]="darkMode"
    [expanded]="true"
    [mode]="getMode(t.deviceId)"
    style="display:block;">
  </app-sparkline-chart>
  <div class="text-muted text-center mt-1" style="font-size:.6rem;">
    {{ sparklinePoints(t.deviceId).length }} {{ 'MESSPUNKTE' | translate }}
  </div>
</ng-template>
